import { motion } from 'framer-motion'
import { Monitor, Smartphone, Building, Building2, Calculator } from 'lucide-react'
import { products } from '../data'
import { Card, CardContent, CardHeader, CardTitle, CardDescription, QRCodeDownload } from '../components/common'

export function ProductsPage() {
  const getIcon = (icon: string) => {
    switch (icon) {
      case 'monitor': return <Monitor className="w-8 h-8 text-primary-500" />;
      case 'smartphone': return <Smartphone className="w-8 h-8 text-primary-500" />;
      case 'building': return <Building className="w-8 h-8 text-primary-500" />;
      case 'building-2': return <Building2 className="w-8 h-8 text-primary-500" />;
      case 'calculator': return <Calculator className="w-8 h-8 text-primary-500" />;
      default: return null;
    }
  }

  return (
    <>
      <section className="relative h-60 bg-gray-900 text-white">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(/images/products-banner.jpg)` }}></div>
        <div className="container-custom h-full flex items-center relative z-10">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">产品中心</h1>
            <p className="text-lg text-white/80">提供全方位的供应链管理客户端产品</p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <motion.h2
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl md:text-4xl font-bold mb-4"
            >
              客户端产品
            </motion.h2>
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg text-gray-600 max-w-2xl mx-auto"
            >
              我们提供多种客户端产品，满足不同角色的使用需求，确保供应链管理的高效运行
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <Card className="h-full">
                  <CardHeader>
                    <div className='flex justify-between items-center gap-3'>
                      <div className="w-10 h-10 bg-primary-100 rounded-2xl flex items-center justify-center ">
                        {getIcon(product.icon)}
                      </div>
                      <QRCodeDownload qrCode={product.qrCode} downloadUrl={product.downloadUrl} />
                    </div>
                    <CardTitle className='!mt-6 !mb-1'>{product.title}</CardTitle>
                    <CardDescription>{product.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2">
                      {product.features.map((feature, i) => (
                        <li key={i} className="flex items-center space-x-2 text-sm text-gray-600">
                          <span className="w-1.5 h-1.5 bg-primary-500 rounded-full flex-shrink-0" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    {/* {
                      product.qrCode && <div className="mt-8" >
                        <div className="bg-gray-100 rounded-lg p-4 inline-block mb-4">
                          <div className="w-32 h-32 bg-white rounded flex items-center justify-center">
                            <span className="text-gray-400 text-sm">下载二维码</span>
                          </div>
                        </div>
                        <Button className="w-full" asChild>
                          <a href={product.downloadUrl}>
                            立即下载
                          </a>
                        </Button>
                      </div>
                    } */}

                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
